// Node Modules
import React from "react";

import DashedLineBreakHeader from "../components/dashedLineBreakHeader/dashedLineBreakHeader";

import "./terms.css";

class Terms extends React.Component {
  render() {
    return (
      <div className="content terms">
        {this.props.policies.privacyPolicy.body !== null && (
          <div>
            <DashedLineBreakHeader title="Privacy Policy" first />
            <p>{this.props.policies.privacyPolicy.body}</p>
          </div>
        )}
        {this.props.policies.refundPolicy.body !== null && (
          <div>
            <DashedLineBreakHeader title="Refund Policy" />
            <p>{this.props.policies.refundPolicy.body}</p>
          </div>
        )}
        {this.props.policies.termsOfService.body !== null && (
          <div>
            <DashedLineBreakHeader title="Terms of Service" />
            <p>{this.props.policies.termsOfService.body}</p>
          </div>
        )}
      </div>
    );
  }
}
export default Terms;
